/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Kind_FailureInputs */

const en_us2_workout_logging_kind_failure = /** @type {(inputs: Workout_Logging_Kind_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To failure`)
};

const pt_br2_workout_logging_kind_failure = /** @type {(inputs: Workout_Logging_Kind_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Até a falha`)
};

const es_419_workout_logging_kind_failure = /** @type {(inputs: Workout_Logging_Kind_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al fallo`)
};

const pt_pt2_workout_logging_kind_failure = /** @type {(inputs: Workout_Logging_Kind_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Até à falha`)
};

const fr_fr2_workout_logging_kind_failure = /** @type {(inputs: Workout_Logging_Kind_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jusqu'à l'échec`)
};

const de_de2_workout_logging_kind_failure = /** @type {(inputs: Workout_Logging_Kind_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis zum Versagen`)
};

const it_it2_workout_logging_kind_failure = /** @type {(inputs: Workout_Logging_Kind_FailureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A cedimento`)
};

/**
* | output |
* | --- |
* | "To failure" |
*
* @param {Workout_Logging_Kind_FailureInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_kind_failure = /** @type {((inputs?: Workout_Logging_Kind_FailureInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Kind_FailureInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_kind_failure(inputs)
	if (locale === "es-419") return es_419_workout_logging_kind_failure(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_kind_failure(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_kind_failure(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_kind_failure(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_kind_failure(inputs)
	return en_us2_workout_logging_kind_failure(inputs)
});
export { workout_logging_kind_failure as "workout-logging.kind_failure" }